import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { Logo } from 'Components';
import { getAppConfig, selectGoogleSettings } from 'Config/configSlice';
import loginBaner from 'Images/loginBanner.png';
import { useAppDispatch, useAppSelector } from 'Store';
import { Colors } from 'Themes/colors';
import { Typo } from 'Themes/typo';

import {
  Banner,
  Container,
  InnerGrid,
  MainGrid,
  SideBanner,
  StyledBannerTittle,
  StyledCard
} from './AuthLayoutRoute.styles';

export const AuthLayoutRoute = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const googleSettings = useAppSelector(selectGoogleSettings);

  useEffect(() => {
    const hasGoogleConfig = googleSettings?.clientId && googleSettings.clientId.trim() !== '';

    if (!hasGoogleConfig) {
      dispatch(getAppConfig());
    }
  }, [dispatch, googleSettings]);

  return (
    <MainGrid>
      <InnerGrid>
        <StyledCard>
          <Container>
            <Outlet />
          </Container>
        </StyledCard>

        <SideBanner>
          <Banner src={loginBaner} />
          <Logo color="dark" variant="login" />
          <StyledBannerTittle variant={Typo.header} color={Colors.white}>
            {t('auth.bannerTittle')}
          </StyledBannerTittle>
        </SideBanner>
      </InnerGrid>
    </MainGrid>
  );
};
